export default Object.freeze({
  PORTUGUESE: "Portuguese",
  ENGLISH: "English",
  SPANISH: "Spanish",
  UPDATING_LANGUAGE_WAITING: "Changing language, wait a moment",
  UNABLE_TO_ALTER_LANGUAGE: "Unable to change the program's language.\n",
  MONITORING: "Protocol",
  PHYS_MEDIUM: "Physical medium",
  GENERAL: "General",
  TS_EXPERT_PROT: "TS Expert - Protocol",
  TS_EXPERT_DP: "TS Expert - Physical medium",
  OSCILLOSCOPE: "Oscilloscope",
  BAR_GRAPH: "Bar graph",
  REPORT: "Report",
  INFOS: "Information",
  RESUME: "Summary",
  CONFIG: "Settings",
  SAVE: "Save",
  REMOVE: "Remove",
  GOOD_STRING_ANALYZER_DN: "Good",
  BAD_STRING_ANALYZER_DN: "Bad",
  MASTER_STRING: "Master",
  NO_SIGNAL_STRING: "No signal",
  UNKNOWN_STRING: "Unknown",
  ADDRESS: "Address",
  NOISE: "Noise",
  SIGNAL: "Signal",
  TURNED_ON: "Turned on ",
  TURNED_OFF: "Turned off ",
  SECOND: " second",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  BEFORE_MONITOR_INIT_STR: "Before last initialization",
  LOG_WAITING: "Loading log data",
  STATUS_CHANGE: "State change: ",
  GENERATE_REPORT: "Generate report",
  ANALYZER_VERSION: "1.2.0",
  REPORT_GENERATION: "- Report generation: ",
  GENERAL_REPORT: "General report – TS Monitor DeviceNet",
  DATA_REPORT: "Data report – TS Monitor DeviceNet",
  CLIENT_INFO: "Client information",
  EXECUTING_COMPANY_INFO: "Executing company information",
  CONFORMITY: "Conformity",
  REPORT_TYPE: "Report type",
  ANNOTATIONS: "Notes",
  CONCLUSION: "Conclusion",
  DROPDOWN_PLACEHOLDER: "Choose an option",
  PROJECT_NAME: "- Project name:",
  NETWORK_NAME: "- Network name:",
  LOCATION: "- Location:",
  COMPANY_NAME: "- Company name:",
  ACCOUNTABLE_NAME: "- Name of person in charge:",
  COMPANY_ADDRESS: "- Address:",
  COMPANY_CITY: "- City:",
  COMPANY_TEL: "- Telephone:",
  EXECUTING_COMPANY_NAME: "- Company name:",
  EXECUTING_ACCOUNTABLE_NAME: "- Name of person in charge:",
  EXECUTING_TEL: "- Telephone:",
  SUMMARY: "Summary",
  HARDWARE_VERSION: "Hardware version",
  ETHERNET_INFO: "ETHERNET information",
  LIVE_LIST_DOTS_ANALYZER_DN: "........................................................................................................................................",
  BAR_DOTS: ".........................................................................................................................",
  OSC_DOTS: "................................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  DISCLAIMER_DOTS_ANALYZER_DN: "....................................................................................................................................",
  GENERATING_REPORT_WAITING: "Generating report, please wait",
  GENERATING_REPORT_SUCCESS: "The report was generated successfully. To save it, click on save report below.",
  MODEL: "Model",
  HORARY: "Time",
  DESCRIPTION: "Description",
  LAST_200_EVENTS: "200 last events",
  END_OF_REPORT: "End of report",
  DISCLAIMER: "Legal notice",
  DISCLAIMER_TEXT: "The data and values presented in this report are merely auxiliary for the DeviceNet specialist, in such a way that any correction indication must be made by the user. For this reason, it is recommended to be accompanied by a DeviceNet certified engineer or technician responsible for the analysis to certify the information provided by the product. Therefore, Toledo & Souza disclaims any liability, loss or damage, direct or indirect, caused by the interpretations of the software, not offering any guarantee in relation to the integrity, quality or adequacy of the information provided, as they depend on the technical analysis of a trained professional, in the absence of this, the user will assume the risk that the content may be inaccurate, incomplete or may not meet their needs and requirements.",
  ENTER: "Enter",
  TAGS: "Device tags",
  SETUP: "Setup",
  EDIT: "Edit",
  SOFTWARE_UPDATE: "Software update",
  INTERFACE_CONFIG: "Interface settings",
  CURRENT_VERSION: "Current version: ",
  UPDATE: "Update",
  ALTER_LOGIN: "Change login",
  INVALID_OR_CORRUPT_FILE: "The file is not valid or is corrupt.",
  IMPORT: "Import",
  EXPORT: "Export",
  LOGIN_CREDENTIALS_FAILURE: "An error occurred while logging in: The username or password are incorrect.",
  LOGIN_GENERAL_FALIURE: "An error occurred while logging in",
  GPG_ALERT_MESSAGE: "It is only possible to send files with a .gpg extension",
  SEND_FILE_SUCCESS: "The file was sent successfully.",
  SEND_FILE_SUCCESS_WARNING: "Don't forget to check if your computer's network card is on the same IP subnet as: ",
  SEND_FILE_FAILURE: "An error occurred while sending the file.",
  SEND_FILE_WAITING: "Sending the file.",
  SEND_FILE_CORRUPTED_FILE: "The update file was corrupted while the upload was in proccess.",
  SEND_CONFIG_SUCCESS: "The settings have been sent successfully.",
  SEND_CONFIG_FAILURE: "An error occurred while sending the settings.",
  SEND_CONFIG_WAITING: "Sending settings.",
  SEND_CONFIG_WAITING_2: "Finishing sending the settings.",
  SEND_CONFIG_DONE: "Sent settings.",
  START_MESSAGE_SUCCESS: "The monitor will start in 15 seconds.",
  START_MESSAGE_FAILURE: "There was an error while starting the monitor.",
  STOP_MESSAGE_SUCCESS: "The monitor will stop in 15 seconds.",
  STOP_MESSAGE_FAILURE: "An error occurred while stopping the monitor.",
  RESET_TRAFFIC_SUCCESS: "The values will be zeroed on the next scan.",
  RESET_TRAFFIC_FAILURE: "An error occurred while resetting the error increments.",
  RESET_DEVICES_SUCCESS: "Device data has been cleared successfully.",
  RESET_DEVICES_FAILURE: "An error occurred while clearing device data.",
  CHANGE_USERNAME_SUCCESS: "The username has been changed successfully. Please login again.",
  CHANGE_USERNAME_FAILURE: "An error occurred while changing the username:",
  USERNAME_TOO_SHORT: "The username must contain at least one character.",
  PASSWORD_MISSMATCH: "The passwords entered do not match",
  CHANGE_PASSWORD_SUCCESS: "The password has been changed successfully. Please login again.",
  CHANGE_PASSWORD_FAILURE: "An error occurred while changing the password: ",
  VERIFY_THE_FOLLOWING_INFO: "Please check the following information:",
  INVALID_IP: "\n- The IP entered is invalid",
  INVALID_SUBMASK: "\n- The mask entered is invalid",
  INVALID_GATEWAY: "\n- The gateway entered is invalid",
  INVALID_DNS: "\n- The DNS entered is invalid",
  LOOPBACK_IP_NTP: "\n- Loopback IP (127.0.0.1) cannot be used as the NTP server IP",
  EMPTY_WIFI_PWD: "\n- Wifi password cannot be empty",
  SELECT_TIMEZONE: "\n- It is necessary to select a Timezone to configure the NTP server",
  ALTER_USERNAME: "CHANGE USER",
  ALTER_PASSWORD: "CHANGE PASSWORD",
  CONFIRM_RESTART_SYSTEM: "Are you sure you want to restart the system?",
  RESTART_SYSTEM_FAILURE: "An error occurred while trying to restart the system.",
  RESTART_SYSTEM_SUCCESS: "The reset request was sent successfully. Wait about 3 minutes for the system to restart completely.",
  SELECT_FILE: "Please select a file to upload",
  DO_NOT_CLOSE_THIS_TAB: "Leave this tab open to keep track of the update.",
  UPDATE_SUCCESS: "The update was applied successfully!",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modify at least one of the fields to update the interface settings.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRemember to update the address in the browser to: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "Interface settings were updated successfully!",
  ALTER: "Change",
  NO: "No",
  YES: "Yes",
  NOTE: "Note",
  TS_EXPERT_CONFIG_POPUP: "Allows enabling / disabling of the non-conformities to be reported by the tool.",
  SEND_NTP_CONFIG_WAITING: "Sending NTP server settings.",
  SEND_NTP_CONFIG_DONE: "NTP Server Settings have been sent.",
  NTP_SERVER: "NTP server",
  TURN_NTP_SERVER_ON: "Turn NTP server on",
  PROCESSING_NTP_INIT: "Starting processing of NTP server information.",
  PROCESSING_NTP_INFO: "Processing NTP server information.",
  PROCESSED_NTP_INFO: "Processed NTP server information.",
  PROCESSING_NTP_ERROR: "An error occurred while sending the information to the NTP server. Check that the server's IP address is correct. If so, also check if the NTP service is turned on and try again.",
  NTP_INFO_TURNED_ON_SUCCESS: "The NTP server was turned on successfully.",
  NTP_INFO_TURNED_ON_FAILURE: "An error occurred while turning the NTP server on.",
  NTP_INFO_FAILURE: "Failed to sync with the NTP server. If the error persists, contact the administrator of the NTP server.",
  TURN_ON_DATE: "\nServer time has been updated to: ",
  MONITOR_WILL_BE_RESTARTED: "\nThe monitor will restart now,",
  NTP_INFO_TURNED_OFF_SUCCESS: "The NTP server was turned off successfully.",
  NTP_INFO_TURNED_OFF_FAILURE: "An error occurred while turning off the NTP server.",
  TURN_OFF_DATE: "\nShutdown time: ",
  WAITING: "Wait a moment",
  CLEAN_LOG_SUCCESS: "The log has been cleared successfully.",
  CLEAN_LOG_FAILURE: "An error occurred while clearing the log.",
  CLEAR: "Clear",
  HOSTNAME_CONFIG_SUCCESS: "The hostname has been configured successfully.",
  HOSTNAME_CONFIG_ERROR: "There was an error configuring the hostname",
  MODE: "Mode",
  HIDDEN_SSID: "Hidden SSID",
  OPTIONAL: " (Optional)",
  ADD_ALTER_TAGS: "Add/Edit Tags",
  CHOOSE_DEVICE: "Choose a device",
  NEW_TAG: "New tag",
  REMOVE_ALL_TAGS: "Remove all tags",
  CONFIRM_REMOVE_ALL_TAGS: "Are you sure you want to remove the tags from all devices?",
  CHANGE_TAG_SUCCESS: "The tag was changed successfully.",
  CHANGE_TAG_FAILURE: "An error occurred while changing the tag.",
  REMOVE_TAG_SUCCESS: "The tags were removed successfully.",
  REMOVE_TAG_FAILURE: "An error occurred while removing the tags.",
  IMPORT_TAGS_SUCCESS: "The tags were imported successfully.",
  IMPORT_TAGS_FAILURE: "An error occurred while importing the tags: ",
  PLEASE_SELECT_TAG_FILE: "Please select a tag file.",
  IMPORT_TAGS: "Import tags",
  EXPORT_TAGS: "Export tags",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Updating TS Expert settings, please wait a moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "TS Expert settings have been saved successfully.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "An error occurred while saving the TS Expert settings.",
  TS_EXPERT_CONFIGURATION: "TS Expert Settings",
  TS_EXPERT_POPUP_1: "This tab displays the TS Expert information.",
  TS_EXPERT_POPUP_3: "In an automated way, maintenance, engineering and related teams can obtain a list of actions with different events, their possible causes, solution suggestions and the devices on which they were detected.",
  TS_EXPERT_POPUP_4: "The use of TS Expert does not exclude the need for human analysis, nor does it replace such capabilities to create data correlations and interpretation.",
  DETECTED_ON: "Detected in: ",
  CHECK_YOUR_NETWORK: "Please check your network.",
  EXPORT_ACTIONS_LIST: "Export actions list",
  GENERATING_ACTIONS_LIST_WAITING: "Generating actions list PDF, please wait.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generated successfully. To save it, click on save actions list.",
  EVENTS_LIST: "Events list",
  ACTIONS: "Actions",
  NO_PROBLEM_DETECTED: "TS Expert has not detected any events on the network.",
  NO_EVENTS_TO_BE_ANALYZED: "There are no events to be analyzed.",
  NO_EVENT_SELECTED: "No event selected",
  CHOOSE_AN_EVENT: "Choose an event to view suggested actions.",
  DETAILING: "Detailing",
  CHECKED: "Check",
  BATCH_CHECK: "Check all",
  PROBLEM_CHECKED: "The event was successfully checked",
  PROBLEM_CHECK_ERROR: "An error occurred while checking the event.",
  QUANTITY_DP: "Quantity: ",
  INCREMENTS: "Increments",
  PORT_IS_STILL_INACTIVE: "The port is still inactive",
  MARK_PROBLEM_AS_SOLVED: "Are you sure you want to mark the event as checked?",
  LAST_UPDATED: "Last updated on: ",
  THIS_COMPUTER_TIME: " (This computer's time)",
  DEVICE: "Device",
  DEVICES: "Devices",
  UNKNOWN: "Unknown",
  ATTENTION_SIGNAL_DOTS: "................................................",
  CAPACITIVE_EFFECT_DOTS: "............................................................................................................................",
  NO_TERMINATION_DOTS: "........................................................................................................",
  NO_POWER_SUPPLY_DOTS: "....................................................................................................",
  BAD_SIGNAL_DOTS: ".............................................................................",
  A_NOT_OK_DOTS: "...........................................................................................",
  B_NOT_OK_DOTS: "...........................................................................................",
  LONG_CABLE_DOTS: "..................................................................................................................................",
  NOISE_DOTS: "..............................................................................................................................................",
  REFLECTION_DOTS: "........................................................................................................",
  DEFORMED_WAVE_DOTS: ".......................................................................................................................",
  DEFORMED_WAVE_DOTS_2: ".........................................................................................................................",
  DUPLICATE_ADDRESS_DOTS: "..................................................................................................................",
  DUPLICATE_ADDRESS_DOTS_2: "....................................................................................................................",
  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2_ANALYZER_DN: "...................................................................................................................................",
  WLAN_STATUS: "WLAN adapter",
  WLAN_CONFIG: "WLAN settings",
  CONNECTION_STATUS: "Connection state",
  WLAN_ADAPTER_ON: "Turned on",
  WLAN_ADAPTER_OFF: "Turned off",
  IP_PLACEHODLER_ANALYZER_DN: "192.168.2.210",
  SIGNAL_STRENGTH: "Signal strength",
  FREQUENCY: "Frequency",
  CHANNEL: "Channel",
  QUALITY: "Quality",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Quality",
  TURNING_WLAN_OFF_WAITING: "Turning off the WLAN adapter, please wait.",
  TURNING_WLAN_ON_WAITING: "Turning on the WLAN adapter, please wait.",
  NETWORK: "Network",
  NETWORK_NAME_1: "Network name",
  SUBMASK: "Mask",
  PASSWORD: "Password",
  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",
  WLAN_STATUS_POPUP_2: "If it is turned off it is not possible to change the WLAN settings.",
  WLAN_CONFIG_POPUP_1: "It is not possible to change the settings while the WLAN adapter is turned off.",
  WLAN_CONFIG_POPUP_3: "When changing the IP / mask, if the fields appear blank after the update this is a strong indication that:",
  WLAN_CONFIG_POPUP_4: "There is already another device on the network with the same IP;",
  WLAN_CONFIG_POPUP_5: "The netmask is too strict and does not support the IP that was entered.",
  WLAN_ADAPTER_NOT_FOUND_4: "  • If none of the previous options solves the problem, contact Toledo e Souza.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modify at least one of the fields to update the WLAN settings.",
  UPDATE_WLAN_CONFIG_SUCCESS: "WLAN settings were updated successfully!",
  SEND_WLAN_CONFIG_WAITING: "Sending settings, please wait. This might take about a minute.",
  LOADING_WAITING: "Loading info, please wait.",
  WLAN_INFO: "WLAN information",
  REASON_DP: "Reason: ",
  SEARCH: "Search",
  STATISTICS: "Statistics",
  AVAILABILITY: "Availability",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  REASON: "\nReason: ",
  SEND_FILES_SUCCESS: "The files were sent successfully.",
  SAME_SUBNET_IP_1: "\n- The IP address of the office interface cannot be in the same subnet as the DeviceNet interface.",
  SAME_SUBNET_IP_2: "\n- The IP address of the DeviceNet interface cannot be in the same subnet as the office interface.",
  SUBNET_OVERLAP_WLAN: "\n- The TS Monitor DeviceNet detected that there is an overlap of addresses between the DeviceNet interface subnet and the WLAN subnet. For this reason, it is not possible to configure the WLAN with the chosen IP address and mask.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 cannot be used as the monitor's IP",
  ZERO_IP_MASK_MSG: "\n- IP 0.0.0.0 cannot be used as a network mask",
  BROADCAST_IP_MSG: "\n- The network broadcast IP cannot be used as the monitor's IP",
  NETWORK_IP_MSG: "\n- The network IP cannot be used as the monitor IP",
  BROADCAST_GATEWAY_MSG: "\n- The network's broadcast IP cannot be used as the gateway IP",
  NETWORK_GATEWAY_MSG: "\n- The network's IP cannot be used as the gateway IP",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "An error occurred while sending the following GSDML files: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "An error occurred while removing the following GSDML files: ",
  MANAGE: "Manage",
  SEND: "Send",
  IP_PLACEHODLER_PROTOCOL: "192.168.2.215",
  HOSTNAME_POPUP_1: "A hostname must be between 2 and 64 characters to be valid.",
  HOSTNAME_POPUP_2: "Also, it can only contain letters, numbers, periods and hyphens, and it must start and end with only letters and numbers.",
  INVALID_HOSTNAME_1: "The hostname must be between 2 and 64 characters long.",
  INVALID_HOSTNAME_2: "The hostname must contain only letters, numbers, periods and hyphens, and must start and end with only letters and numbers.",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Please select at least one file to remove",
  MONITORING_INFO: "Monitoring information",
  CONFORM_STRING: "Conform",
  CONFORM_W_RESTRICTION_STRING: "Conform with restrictions",
  NON_CONFORM_STRING: "Not conform",
  TS_MONITOR_VER_DP: "TS Monitor DeviceNet - Version ",
  NETWORK_AVAILABILITY_DP: "Network availability: ",
  DEVICE_DATA: "Device data",
  MATRIX: "Matrix",
  GRAPHIC_TOPOLOGY: "Graphic Topology",
  CONFIG_STRING: "Settings",
  RESUME_DOTS: ".......................................................................................................................................",
  LIVE_LIST_DOTS_PROTOCOL: ".......................................................................................................................................",
  MON_LOG_DOTS: "................................................................................................................................................",
  DISCLAIMER_DOTS_PROTOCOL: "...................................................................................................................................",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "1.2. Live List",
  M_MONITORING_LOG_PAGE_TITLE: "1.3. - Event log",
  CONFIG_ERROR_STRING: "Configuration error",
  FAULT_STRING: "Fault",
  CLASS_2: "",
  REMOVE_DEVICE_SUCCESS: "The device will be removed in up to 30 seconds.",
  REMOVE_DEVICE_FAILURE: "An error occurred while removing the device.: ",
  WITH_DIAGNOSTIC_STRING: "With diagnostics",
  WITH_FAILURE_STRING: "With fault",
  LAST_EVENT: "Last event: ",
  BILLIONS_OF: "Billions of",
  MILLIONS_OF: "Millions of",
  THOUSAND: "Thousand",
  FAULTS_QUESTION_INFO: "Indicates the number of times that a DeviceNet device did not respond to messages sent by TS Monitor.",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Search by IP, Tag or profiname",
  SAVE_TOPOLOGY_POS_STRING: "Save",
  DELETE_TOPOLOGY_POS_STRING: "Remove",
  EXPORT_TOPOLOGY: "Topology",
  IMPORT_TOPOLOGY: "Import Topology",
  POSITION: "Position",
  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "The topology positioning was saved successfully!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred while saving the topology positioning: ",
  DROP_TOPOLOGY_POS_SUCCESS_STRING: "The topology positioning was removed successfully!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred when removing topology positioning: ",
  ASK_REMOVE_POSITIONING: "Are you sure you want to remove the currently saved positioning? To confirm the removal it is necessary to enter the login information.",
  REMOVE_POSITIONING: "Remove positioning",
  ALERT_CHOOSE_DEVICE_TYPE: "Please select a device type",
  ADD_DEVICE: "Add device",
  TAG_PLACEHOLDER: "TAG",
  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a device type",
  CANCEL: "Cancel",
  ADD: "Add",
  LOCALE_EDIT: "Edit",
  LOCALE_DEL: "Remover selected",
  LOCALE_BACK: "Back",
  LOCALE_ADD_NODE: "Add device",
  LOCALE_ADD_EDGE: "Add connection",
  LOCALE_EDIT_NODE: "Edit device",
  LOCALE_EDIT_EDGE: "Edit connection",
  LOCALE_ADD_DESCRIPTION: "Click on a blank space to add a new device",
  LOCALE_EDGE_DESCRIPTION: "Click on a device and drag the connection to another device to connect them.",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Click and drag control points to a device to connect them",
  LOCALE_CREATE_EDGE_ERROR: "Unable to create connection to a cluster",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters cannot be removed",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters cannot be edited",
  TOPOLOGY_IMPORT_SUCCESS: "The topology was imported successfully!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "An error occurred while importing the graphical topology: ",
  PLEASE_SELECT_TOPOLOGY_FILE: "Please select a topology file.",
  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnostics",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "If on, TS Expert will log every time a DeviceNet device has diagnostics. Diagnostic is an abnormal condition or malfunction information sent by the IO Device to the IO Controller, requesting maintenance or even replacement.",
  CONFIG_FAULT_LIST_HEADER: "Faults",
  CONFIG_FAULT_LIST_CONTENT: "If on, TS Expert will log every time a DeviceNet device has faults. This indicates that it is not responding to ping and arp commands over the network, that is, it is not accessible via the network.",
  DIAGNOSTIC_LIST_HEADER: "There are devices on the network that have diagnostics.",
  DEVICE_WITH_DIAGNOSTIC: "Device with diagnostic (First Detection)",
  DIAGNOSTIC_SUGGESTION_1: "When a device has diagnostics it is suggested to:",
  DIAGNOSTIC_SUGGESTION_2: "Check the information sent by the IO Device itself (detected and transformed into text by the TS Monitor) and try to solve the problem. If you have difficulty understanding the diagnostic, contact the device manufacturer or check the IO Device manual to clear your doubts before an intervention.",
  DEVICE_WITH_FAULT: "Device with faults (First Detection)",
  FAULT_SUGGESTION_1: "When a device has faults, it is suggested to:",
  FAULT_SUGGESTION_2: "Check the IO Device power supply;",
  FAULT_SUGGESTION_3: "Check if it is physically connected to the network;",
  FAULT_SUGGESTION_4: "Check the connector's integrity;",
  FAULT_SUGGESTION_5: "Check the cable's integrity;",
  FAULT_SUGGESTION_6: "Check if the device has lost its IP address. If this happens, the device will appear on the monitor with the IP: 0.0.0.0, its IP will also be marked in orange in the Live List.",
  DEVICE_WITH_RETRIES_DOTS: "........................................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: ".........................................................................................................................",
  DEVICE_WITH_FAULT_DOTS: ".........................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: ".........................................................................................",
  DEVICE_WITH_ERROR_FRAME_DOTS: "....................................................................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: ".....................................................................................",
  DEVICE_MISSING_DOTS: ".......................................................................................................................",
  DEVICE_ONLINE_DOTS: "..........................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: "..................................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "...............................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "...................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2_PROTOCOL: "......................................................................................................................................",
  ALL_EVENTS_CHECKED_SUCCESS: "All events were checked successfully.",
  SIGNAL_QUALITY: "Signal quality",
  SIGNAL_QUALITY_DESCRIPTION: "The worst case is always considered in the Signal column, for average and minimum amplitude.",
  ATTENTION_PREVENTIVE_ACTION: "Attention - Preventive action",
  BAD_CORRECTIVE_ACTION: "Bad - Corrective action",
  DIAGNOSTIC_BYTE: "DIAGNOSTIC BYTE",
  ENABLE_DIAGNOSTIC: "Enable Diagnostics",
  ENABLE_DIAGNOSTIC_BIT: "Enable Diagnostics Bit ",
  INTERFACE_CONFIGURATION: "Interface settings",
  CONFIGURE: "Configure",
  NEW_PASSWORD: "New password",
  REPEAT_PASSWORD: "Repeat password",
  CLIENT_LOGO: "Client logo",
  EXECUTING_COMPANY_LOGO: "Executing company logo",
  TS_MONITOR_LOGO_ALT: "TS Monitor logo",
  HORARY_DETECTION: "Detection time",
  ERROR_FRAMES: "Error frames",
  USERNAME: "Username",
  FIXED_IP: "Fixed IP",
  TEST_NETWORK: "Test network",
  AVAILABLE_DEVICES_PLACEHOLDER: "Devices",
  OBSERVATION_ABBREVIATION: "NOTE",
  NOTE_ABBREVIATION: "Note",
  FORM_PROJECT_NAME: "Project name",
  FORM_NETWORK_NAME: "Network name",
  FORM_LOCATION: "Location",
  FORM_COMPANY_NAME: "Company name",
  FORM_ACCOUNTABLE_NAME: "Responsible person",
  FORM_ADDRESS: "Address",
  FORM_CITY: "City",
  FORM_PHONE: "Phone",
  DIAGNOSTIC: "Diagnostics",
  ACTIONS_LIST: "Actions list",
  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matrix",
  LOG: "Log",
  TIME_ON_ANALYZER_DN: "Analysis time: ",
  ATTENTION_STRING: "Attention",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_ANALYZER_DN: "Filter by address or sign",
  ADDRESSES: "Addresses",
  AMPLITUDE: "Amplitude",
  AMPLITUDE_PRE: "Preamble amplitude",
  MEAN_AMPLITUDE: "Average amplitude",
  MEAN_AMPLITUDE_N: "Amplitude\naverage",
  MIN_AMPLITUDE: "Minimum amplitude",
  MIN_AMPLITUDE_N: "Amplitude\nminimum",
  MAX_AMPLITUDE: "Outstanding",
  STATUS: "Status",
  RATIO: "Reason",
  NETWORK_TAG: "Segment Tag: ",
  IS_IN_SEGMENT: "Belongs to\nSegment?",
  IS_IN_SEGMENT_1: "Belongs to",
  IS_IN_SEGMENT_2: "Segment?",
  IS_IN_SEGMENT_DP: "Belongs to the Segment: ",
  IS_IN_SEGMENT_QUESTION: "Does it belong to the Segment?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indicates whether the device belongs to the same segment as this TS Monitor DN.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "This option must be adjusted manually for each device in the settings screen.",
  MIN_AMPLITUDE_1: "Amplitude",
  MIN_AMPLITUDE_2: "minimum",
  MEAN_AMPLITUDE_1: "Amplitude",
  MEAN_AMPLITUDE_2: "average",
  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "This column is an indicator of problems on channel A, green wire, such as:",
  CHANNEL_B_PROBLEM: "This column is an indicator of problems on channel B, red wire, such as:",
  MASTERS: "Masters",
  SLAVES: "Devices",
  AMPLITUDE_IDLE: "Idle voltage ",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",
  NETWORK_DATA: "Network data",
  MODAL_TITLE: "Characteristic waveforms",
  ANALYSIS_ERROR: "An error occurred when changing the analysis status",
  ANALYSIS: "Analysis",
  ANALYZER: "TS Monitor DN ",
  DETECTED_PROBLEMS: "Problems detected:",
  INIT_PICO_NOT_FOUND: "TS Monitor DN not found, please connect it to the computer.",
  MONGO_OFF: "TS Monitor DN detected an error in its internal database. Please restart TS Monitor DN. If the problem persists, contact Toledo & Souza for support.",
  PICO_NOT_FOUND: "TS Monitor DN encountered an internal error that prevented it from functioning correctly. Please restart TS Monitor DN. If the problem persists, contact Toledo & Souza for support.",
  MONGO_REPAIR_SUCCESS: "Error successfully fixed! Please close the program and reopen it for the changes to take effect.",
  MONGO_REPAIR_ERROR: "The problem could not be resolved. Please get in touch for support.",
  INIT_PICO_NOT_FOUND_PLAY: "Error starting TS Monitor DN. Please disconnect it from your computer, connect it again, and restart the program. If the error persists, restart your computer and try again.",
  REPAIR: "Repair",
  LOADING_ANALYZER: "Starting TS Monitor DN, please wait.",
  NO_DP_ACTIVE_NETWORK: "TS Monitor DN did not find an active network, make sure it is correctly connected to a DeviceNet DP network and try again.",
  INVALID_SERIAL: "The serial number does not match this TS Monitor DN. Please reinstall the program with a valid serial number.",
  MONGO_OFF_POPUP: "Error initializing database, click the button below to fix the problem.",
  MEAN_AMPLITUDE_DESC: "Amplitude value measured between the average of the points at a high logic level and the average of the points at a low logic level, as illustrated in the figure below.",
  MEAN_AMPLITUDE_DESC_2: "High average amplitude is indicative of a lack of terminators. When this low indicates: Resistance in connections; excess terminators; pressed cables; bent or bent cables, etc.",
  AMPLITUDE_MIN_DESC: "Amplitude value between the smallest point of the waveform at a high logic level and the largest point at a low logic level, as illustrated in the figure below.",
  AMPLITUDE_MIN_DESC_2: "A large difference between the average and minimum amplitude indicates: Reflection (terminators); long handle; noise; humidity in the bus, etc.",
  OVERSHOOTING_DESC: "Amplitude value between the average value of the waveform at a high logic level and the largest point at a high logic level, as illustrated in the figure below.",
  OVERSHOOTING_DESC_2: "Indicates: Lack of terminators; connections in the middle of the bus; derivations etc.",
  RATIO_DESC_1: "Ratio between the minimum amplitude and average amplitude values, in order to make signal degradation evident.",
  RATIO_DESC_2: "The closer to 1 the better, and the closer to 0 (zero) the worse the signal quality.",
  RATIO_FOMULA: "Ratio = Amp. minimum / Amp. average",
  IDLE_DESCRIPTION: " Period in which the network is idle, that is, the period between a question from the master and the response from the device, or between packets from the master to itself. The ideal idle voltage is 1V, different values ​​indicate problems in the network.",
  MONITOR_IP_NOT_FOUND: "Monitor IP not found",
  SCAN_FAIL_FOUND: "TS Monitor DN has lost connection to the DeviceNet network, make sure it is properly connected to the network. After making the connection, please restart TS Monitor DN.",
  GRAPH: "Chart",
  A_AND_B: "A and B",
  B_A: "B - A",
  WAVE_FORM: "Waveform",
  AMPLITUDE_A: "Amplitude A",
  AMPLITUDE_B: "Amplitude B",
  ADDRESS_DN: "Address: ",
  WAVE_A: "Signal A",
  WAVE_B: "Signal B",
  WAVE_DN: "DeviceNet signal",
  WAVE_PA: "PA signal",
  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  TIME_NS: "Time (ns)",
  TIME_US: "Time (μs)",
  TIME_MS: "Time (ms)",
  TIME_S: "Time(s)",
  AMPLITUDE_PLACEHOLDER: "0.0V",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursors",
  CONTROLS: "Controls ",
  TIME_INTERVAL: " time",
  CONTROLS_POPUP_TEXT: "After pressing PLAY, the waveform is updated approximately every 200 milliseconds.",
  CONTROLS_POPUP_TEXT_2: "To release the controls, you must select manual view and choose a device.",
  SIZE: "Size ",
  VISUALIZATION: "Preview",
  AUTOMATIC: "Automatic",
  MANUAL: "Manual",
  STD_WAVE_FORM: "Standard waveform",
  LONG_CABLE_WAVE_FORM: "Typical long cable waveform",
  EXCESS_TERMINATIOR_WAVE_FORM: "Typical terminator excess waveform",
  NO_SLAVE_WAVE_FORM: "Typical device absence waveform (devices disconnected)",
  REFLECTION_WAVE_FORM: "Typical waveform with reflection",
  NO_TERMINATOR_WAVE_FORM: "Typical missing terminator waveform",
  FOR_MORE_INFO_DP: "For additional information, consult Toledo & Souza or DeviceNet International guidelines. It is worth mentioning that the demonstrated events can happen together, which changes the demonstrated patterns.",
  FEW_TERMINATOR_WAVE_FORM: "Typical waveform of little terminator",
  WAVE_SIZE_DESC_1: "TS Monitor DN already samples the frame in two ways with just 1 Byte or with 3 Bytes, so that here we can view it with a larger zoom in 1 Byte or a smaller zoom in 3 Bytes.",
  WAVE_SIZE_DESC_2: "There is one exception: The frame “E5” – short acknowledgment – ​​always only has 1 Byte.",
  WAVE_SIZE_DESC_3: "Below is an example in a frame with more than 1 and 3 Bytes.",
  TS_SCOPE_NOT_FINDING_ANSWER: "TS Monitor DN is not finding a response from the device, so the data is out of date. The waveform below is the last one captured by the system.",
  ORDER_BY: "Sort by",
  AMPLITUDE_ASC: "Increasing amplitude",
  AMPLITUDE_DESC: "Decreasing amplitude",
  ADDRESS_ASC: "Ascending address",
  VOLTAGE_V: "Voltage (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Voltage (V)",
  VOLTAGE_MV: "Voltage (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Voltage (mV)",
  ORDER: "Ordering",
  REFRESH_DATA: "Update data",
  LOADING: "Loading",
  INSERT_VALID_ADDRESS_OR_TYPE: "Please enter a valid address or event type.",
  LOG_INPUT_TEXT_PLACEHOLDER_ANALYZER_DN: "Filter by address or event type",
  TYPE: "Type",
  ATTENTION_SIGNAL_LOG_DESCRIPTION: "The TS Expert detected a signal with low amplitude (Signal in Attention state).",
  NO_TERMINATION_LOG_DESCRIPTION: "TS Expert detected a possible lack of terminator on the segment to which it is connected.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "TS Expert has detected a possible lack of power in the terminator.",
  BAD_SIGNAL_LOG_DESCRIPTION: "The TS Expert detected a signal with low amplitude (Bad Signal).",
  A_NOT_OK_LOG_DESCRIPTION: "The TS Expert detected a possible short circuit between conductor A and the shielding mesh, or the grounded mass of a panel or device.",
  B_NOT_OK_LOG_DESCRIPTION: "The TS Expert detected a possible short circuit between conductor B and the shielding mesh, or the grounded mass of a panel or device.",
  LONG_CABLE_LOG_DESCRIPTION: "TS Expert detected a possible bus length condition longer than allowed.",
  REFLECTION_LOG_DESCRIPTION: "TS Expert detected the presence of reflection in the waveform.",
  DEFORMED_WAVE_LOG_DESCRIPTION: "TS Expert detected the presence of a non-standard signal.",
  DUPLICATE_LOG_DESCRIPTION: "TS Expert detected the possible presence of two devices with the same address on the network.",
  EVENT_CHECKED_SUCCESS_ANALYZER_DN: "The event was successfully held.",
  REPORT_EXPORT_NAME_ANALYZER_DN: "Report TS Monitor DeviceNet - Physical Medium",
  HEADER_TEXT_ANALYZER_DN: "Data report - TS Monitor DeviceNet - Physical Medium",
  ANALYZER_VERSION_STRING: "- Monitor version:",
  PROTOCOL: "- Protocol:",
  PROTOCOL_TYPE: "DeviceNet",
  ANALYSIS_INIT: "- Start of monitoring:",
  ANALYSIS_DURATION: "- Duration of monitoring until report generation: ",
  CONFORM: "As per",
  CONFORM_W_RESTRICTION: "Compliant with restrictions",
  NON_CONFORM: "Non-conforming",
  EXECUTING_EMAIL: "- Email:",
  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2. - Oscilloscope",
  A_BAR_GRAPH_PAGE_TITLE: "3. - Bar chart",
  A_LOG_PAGE_TITLE: "4. - Event log",
  B_LIVE_LIST_PAGE_TITLE: "2.1. - Live List",
  B_OSCILLOSCOPE_PAGE_TITLE: "2.2. - Oscilloscope",
  B_BAR_GRAPH_PAGE_TITLE: "2.3. - Bar chart",
  B_LOG_PAGE_TITLE: "2.4. - Event log",
  ANALYSIS_INFO: "Monitoring information",
  GENERATED_BY: "- Generated by TS Monitor DN",
  SOFTWARE_VERSION: "- Software version:",
  DATE_TIME: "- Date and time:",
  BAUD_RATE_ANALYZER_DN: "- Baud rate:",
  CYCLE_TIME_ANALYZER_DN: "- Cycle time:",
  NUM_MASTERS: "- Masters:",
  NUM_SLAVES: "- Devices:",
  AMPLITUDE_IDLE_1: "- Idle voltage:",
  REDE_TAG: "- Network Tag: ",
  IP_DN: "- IP: ",
  MASK_DN: "- Mask: ",
  GATEWAY_DN: "- Gateway: ",
  NETWORK_NAME_DN: "- Network name: ",
  SELECT_REPORT_TYPE: "Please select a report type",
  MASTER_DN: "Master: ",
  SLAVE_DN: "Device: ",
  SIGNAL_DN: "Signal: ",
  AMPLITUDE_DP: "Amplitude: ",
  AMPLITUDE_PRE_DP: "Preamble amplitude: ",
  AMPLITUDE_MIN_DN: "Minimum amplitude: ",
  OVERSHOOTING_DP: "Extra: ",
  AMPLITUDE_MAX_DP: "Maximum amplitude: ",
  GENERAL_INFORMATION: "General information",
  CAPTURE_TIME: "Capture time",
  LOGIN: "LOGIN",
  LOGOUT: "Logout",
  RESTART_SYSTEM_ANALYZER_DN: "Restart System",
  IP: "IP",
  MASK: "Mask",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  ARE_YOU_SURE_ALTER_CONFIG_ANALYZER_DN: "Are you sure you want to change the Ethernet settings for TS Monitor DN?",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_WRONG_FILENAME_ANALYZER_DN: "Invalid name. The update file must be called: updateRMDP.tar.gz.gpg",
  CLEAN_STATISTICS_SUCCESS: "Statistics have been successfully cleared.",
  CLEAN_STATISTICS_FAILURE: "An error occurred while clearing statistics.",
  RESET_RETRIES_SUCCESS: "The retries were successfully cleared.",
  RESET_RETRIES_FAILURE: "An error occurred while clearing retries.",
  LOOPBACK_IP_ANALYZER_DN: "\n- The loopback IP (127.0.0.1) cannot be used as the IP of the TS Monitor DN",
  TAG_TOO_LONG_ANALYZER_DN: "\n- Tag length cannot exceed 30 characters",
  SYSTEM: "System",
  RESTART: "Restart",
  SELECT_GSD_FLIE: "Please select at least one GSD file to be sent",
  SENDING_GSD_FILES: "Sending GSD files",
  UPDATING_MONITOR_FILES_ANALYZER_DN: "Updating files in TS Monitor DN. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY_ANALYZER_DN: "Updated files, preparing to restart TS Monitor DN.",
  RESTARTING_MONITOR_WAIT_ANALYZER_DN: "Restarting TS Monitor DN, wait a few minutes.",
  UPDATE_ERROR_STRING_ANALYZER_DN: "The following error occurred when updating TS Monitor DN: ",
  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• The IP of TS Monitor DN was successfully modified.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• The observation was successfully modified.",
  MONITOR_IP: "Monitor IP",
  IN_SEGMENT_DEVICES: "Segment devices",
  UPDATING_DATA: "Updating information, please wait",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filter devices by address",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "List of devices belonging to the same segment as TS Monitor DN.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "If the device is unchecked in this list, it means that it does not belong to the same segment as TS Monitor DN.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "If it does not belong to the same segment, the waveform seen on the oscilloscope may not match the actual waveform on the device.",
  CONFIRM_ALTER_SEGMENT_DEVICES: "Are you sure you want to make changes to the list of devices belonging to the segment?",
  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "An error occurred while changing the segment device list.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "The segment device list has been changed successfully!",
  TURN_NTP_SERVER_ON_QUESTION_ANALYZER_DN: "Are you sure you want to turn on the NTP server? To do this, TS Monitor DN will need to be restarted.",
  MONITOR_RESTART_SUCCESS_ANALYZER_DN: "TS Monitor DN has been successfully reset.",
  MONITOR_RESTART_FAILURE_ANALYZER_DN: "An error occurred while restarting TS Monitor DN.",
  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Ethernet interface configuration field.",
  ETHERNET_POPUP_2_ANALYZER_DN: "Used for supervision and web access to TS Monitor DN data.",
  WLAN: "WLAN",
  WLAN_POPUP_1: "Wireless interface configuration field, when adapter available.",
  WLAN_POPUP_2_ANALYZER_DN: "Used for supervision and web access to TS Monitor DN data.",
  TAG_CONFIG_ANALYZER_DN: "Segment Tag: ",
  TAG_WAS_CHANGED_SUCCESSFULLY_ANALYZER_DN: "The TS Monitor DN tag was successfully modified.",
  TAG_CHANGE_FAILURE_ANALYZER_DN: "An error occurred when modifying the TS Monitor DN tag.",
  INVALID_MONITOR_IP: "The IP of the inserted monitor is invalid.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "The monitor's IP was successfully modified.",
  MONITOR_IP_CHANGE_FAILURE: "An error occurred while modifying the monitor's IP.",
  INVALID_HOSTNAME: "The hostname must not be blank, nor contain spaces or special characters.",
  ALTER_MONITOR_WLAN_CONFIG_ANALYZER_DN: "Are you sure you want to change the WLAN settings from TS Monitor DN?",
  CHANGE_IDLE_SIZE: "Change idle size",
  CHANGE_IDLE_SIZE_QUESTION_1: "Changing the idle size will restart TS Monitor DeviceNet internal procedures. This procedure may take up to 3 minutes.",
  CHANGE_IDLE_SIZE_QUESTION_2: "When clicking yes, wait on the screen until it finishes. Are you sure you want to proceed?",
  CHANGE_PACKET_SIZE: "Change packet size",
  CHANGE_PACKET_SIZE_QUESTION_1: "Changing the packet size will restart TS Monitor DeviceNet internal procedures. This procedure may take up to 3 minutes.",
  CHANGE_PACKET_SIZE_QUESTION_2: "When clicking yes, wait on the screen until it finishes. Are you sure you want to proceed?",
  BAD_SIGNAL_LIST_HEADER: "There are devices on the network with poor signal.",
  BAD_SIGNAL: "There are devices on the network with poor signal",
  DEVICE_BAD_SIGNAL: "Device with poor signal",
  BAD_SIGNAL_LIST_CONTENT: "When this option is activated, TS Expert will indicate to the user that the signal amplitude is much lower than the standard (Bad Signal).",
  DN_ATTENTION_SIGNAL_LOG_DESCRIPTION: "The TS Expert detected a signal with low amplitude (Signal in Attention state).",
  DN_BAD_SIGNAL_LOG_DESCRIPTION: "The TS Expert detected a signal with low amplitude (Bad Signal).",
  ATTENTION_SIGNAL_LIST_HEADER: "There are devices on the network with a signal in an alert state.",
  ATTENTION_SIGNAL: "There are devices on the network with a signal in an alert state",
  DEVICE_ATTENTION_SIGNAL: "Device with attention signal",
  ATTENTION_SIGNAL_LIST_CONTENT: "When this option is activated, TS Expert will indicate to the user that the signal amplitude is lower than the standard.",
  CAPACITIVE_EFFECT_LIST_HEADER: "Capacitive Effect.",
  NOISE_LIST_HEADER: "Noise.",
  NOISE_LIST_CONTENT: "When this option is activated, TS Expert will indicate to the user a possible noise condition on the DeviceNet network.",
  DEVICE_NOISE: "Noisy device",
  NOISE_LOG_DESCRIPTION: "TS Expert has detected a possible noise condition on the DeviceNet network.",
  CAPACITIVE_EFFECT: "Capacitive Effect",
  DEVICE_CAPACITIVE_EFFECT: "Device with capacitive effect",
  CAPACITIVE_EFFECT_LIST_CONTENT: "When this option is activated, TS Expert will indicate to the user a possible condition of a bus length longer than permitted or a change in impedance.",
  CAPACITIVE_EFFECT_LOG_DESCRIPTION: "TS Expert has detected a capacitive effect condition.",
  TS_EXPERT_REPORT_EXPORT_NAME_ANALYZER_DN: "Action list - TS Expert - TS Monitor DN",
  TS_EXPERT_POPUP_2_ANALYZER_DN: "This tool is an expert system developed to optimize and accelerate the analysis of the main divergences detected by TS Monitor DN in DeviceNet networks.",
  TS_EXPERT: "TS Expert",
  ATTENTION_SIGNAL_SUGGESTION_1: "When the signal amplitude is in a “attention” status, it is suggested to check:",
  ATTENTION_SIGNAL_SUGGESTION_2: "If the network has more than two terminators connected;",
  ATTENTION_SIGNAL_SUGGESTION_3: "Check the electronics of the devices, isolating them individually from the bus;",
  ATTENTION_SIGNAL_SUGGESTION_4: "Check for loose terminals in the terminal connections or terminal connectors;",
  ATTENTION_SIGNAL_SUGGESTION_5: "Check for crushed or damaged cables.",
  ATTENTION_SIGNAL_SUGGESTION_6: "This check can be done with the network working, however for any intervention it is recommended to wait for a stop, as these changes can bring down the network.",
  BAD_SIGNAL_SUGGESTION_1: "When the signal amplitude is in “bad” status, it is suggested to check preventively:",
  BAD_SIGNAL_SUGGESTION_2: "Check:",
  BAD_SIGNAL_SUGGESTION_3: "If the network has more than two terminators connected;",
  BAD_SIGNAL_SUGGESTION_4: "Check the electronics of the devices, isolating them individually from the bus;",
  BAD_SIGNAL_SUGGESTION_5: "Check for loose terminals in the terminal connections or terminal connectors;",
  BAD_SIGNAL_SUGGESTION_6: "Check for crushed or damaged cables.",
  BAD_SIGNAL_SUGGESTION_7: "Check for crushed cables, which would increase the cable's resistance.",
  BAD_SIGNAL_SUGGESTION_8: "This check can be done with the network working, however for any intervention it is recommended to wait for a stop, as these changes can bring down the network.",
  CAPACITIVE_EFFECT_SUGGESTION_1: "When a capacitive effect is detected, it is suggested:",
  CAPACITIVE_EFFECT_SUGGESTION_1_REPORT: "When capacitive effect is detected:",
  CAPACITIVE_EFFECT_SUGGESTION_2: "Perform a visual inspection of the segment and check whether the bus is too long for the current baud rate (communication rate).",
  CAPACITIVE_EFFECT_SUGGESTION_3: "Check the condition of the cabling and replace anything that is not in good condition.",
  NOISE_SUGGESTION_1: "When there is noise or poor insulation (leakage to earth) it is suggested:",
  NOISE_SUGGESTION_2: "This is one of the most complex problems in industrial networks. Below we have 4 basic tips that should help solve this problem:",
  NOISE_SUGGESTION_3: "Check the isolation of the device interfaces, a simple way is to disconnect one by one from the network and check if the problem persists;",
  NOISE_SUGGESTION_4: "To mitigate noise, it is necessary to check that all devices on the network are properly grounded;",
  NOISE_SUGGESTION_5: "It is necessary to check the equipotentialization of the grounding system, a simple way is to check if there is leakage current in the DeviceNet cables. A value below 100mA is expected;",
  NOISE_SUGGESTION_6: "If you have a current greater than 100mA, a tip is to isolate the mesh on the device, always keeping the device grounded.",
  NOISE_SUGGESTION_7: "If the problem persists after following these basic tips, we recommend looking for a DeviceNet network specialist.",
  ATTENTION_SIGNAL_PAGE_TITLE: ". - Signal in state of attention",
  NO_TERMINATION_PAGE_TITLE: ". - Segment without termination",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminator without power",
  BAD_SIGNAL_PAGE_TITLE: ". - Bad signal",
  A_NOT_OK_PAGE_TITLE: ". - Short between conductor A and the mesh",
  B_NOT_OK_PAGE_TITLE: ". - Short between conductor B and the mesh",
  CAPACITIVE_EFFECT_PAGE_TITLE: ". - Capacitive Effect",
  NOISE_PAGE_TITLE: ". - Noise or poor insulation (leakage to earth)",
  REFLECTION_PAGE_TITLE: ". - Reflection in the waveform",
  DEFORMED_WAVE_PAGE_TITLE: ". - Deformed signal",
  DUPLICATE_PAGE_TITLE: ". - Duplicate address",
  SUGGESTION: "It is suggested",
  EVIDENCE: "Evidence",
  EVIDENCE_DESCRIPTION: "Capturing evidence of non-compliance reported by TS Expert:",
  ATTENTION_SIGNAL_PAGE_DESCRIPTION: "TS Expert is indicating that the signal amplitude is lower than the standard (Signal in Attention state).",
  NO_TERMINATION_PAGE_DESCRIPTION: "The TS Expert is indicating a possible absence of a terminator in the segment to which it is connected.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "TS Expert is indicating a possible lack of power in the terminator.",
  BAD_SIGNAL_PAGE_DESCRIPTION: "The TS Expert is indicating that the signal amplitude is much smaller than the standard (Bad Signal).",
  A_NOT_OK_PAGE_DESCRIPTION: "The TS Expert indicates a possible short circuit between conductor A and the shielding mesh or the grounded mass of a panel or device.",
  B_NOT_OK_PAGE_DESCRIPTION: "The TS Expert indicates a possible short circuit between conductor B and the shielding mesh or the grounded mass of a panel or device.",
  CAPACITIVE_EFFECT_PAGE_DESCRIPTION: "The TS Expert is indicating a possible condition of a bus with a length longer than allowed or a change in impedance, the typical causes of which are excessive bending, damaged cables, damp cables and devices with electronic problems.",
  NOISE_PAGE_DESCRIPTION: "TS Expert is indicating a possible noise condition on the DeviceNet network.",
  REFLECTION_PAGE_DESCRIPTION: "The TS Expert is indicating the presence of reflection in the waveform.",
  DEFORMED_WAVE_PAGE_DESCRIPTION: "TS Expert is indicating the presence of a non-standard signal",
  DUPLICATE_PAGE_DESCRIPTION: "The TS Expert is indicating the possible presence of a duplicate address.",
  SSID: "SSID",
  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  ALTER_SCOPE_WLAN_CONFIG: "Are you sure you want to change the WLAN settings from TS Monitor DN?",
  WLAN_STATUS_POPUP_1_ANALYZER_DN: "Indicates the state of the WLAN adapter of TS Monitor DN.",
  CONNECTION_STATUS_POPUP_1_ANALYZER_DN: "Indicates whether or not the TS Monitor DN is connected to the configured WLAN network.",
  WLAN_CONFIG_POPUP_2_ANALYZER_DN: "It is highly recommended that WLAN settings be changed only when accessing TS Monitor DN via the wired network.",
  WLAN_ADAPTER_NOT_FOUND_1_ANALYZER_DN: "TS Monitor DN could not find adapter WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2_ANALYZER_DN: "  • Check if the adapter is disconnected or has poor contact;\n",
  WLAN_ADAPTER_NOT_FOUND_3_ANALYZER_DN: "  • If the adapter is not disconnected or has poor contact, try replacing it;\n",
  MAC: "MAC",
  UPDATE_WLAN_CONFIG_ERROR_ANALYZER_DN: "Unable to connect to the WLAN network. If the problem persists, try restarting the TS Monitor DN or the WLAN router.",
  OK_STRING: "OK",
  IDLE_SIZE: "idle size",
  PACKET_SIZE: "Package size",
  SMALL: "Small",
  MEDIUM: "Medium",
  BIG: "Big",
  IDLE_SIZE_QUESTION_ICON_INFO: "The idle size refers to the number of points considered at the beginning of the device's response waveform. It is possible to configure three different sizes:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Standard idle size (Varies according to baud rate);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Increases size by 1 bit time;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Increases the size by 2 one-bit strokes.",
  PACKET_SIZE_QUESTION_ICON_INFO: "Packet size is the total number of points that are captured by TS Monitor DN in a single data packet. It is possible to configure three different sizes:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Standard packet size (Varies depending on baud rate);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Increases packet size by 100 points;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Increases packet size by 200 points.",
  IDLE_SIZE_WAITING: "Performing procedures to change the idle size, please wait on this screen until they finish.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "The idle size was changed successfully",
  IDLE_SIZE_CHANGE_FAILURE: "An error occurred while changing the idle size.",
  PACKET_SIZE_WAITING: "Performing procedures to change the package size, please wait on this screen until they finish.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "The packet size was changed successfully",
  PACKET_SIZE_CHANGE_FAILURE: "An error occurred while changing the packet size.",
  CHECK_MASTER: "Check Master",
  START_SEARCH_ERROR_MESSAGE: "An error occurred when starting the device search. Please try again.",
  SEARCH_FINISH_SUCCESS: "Search for devices completed successfully!",
  GET_DEVICES_LIST_ERROR: "An error occurred while loading the device list.",
  IN_SEGMENT: "Currently in the segment",
  POSSIBLY_IN_SEGMENT: "Identified as belonging",
  POSSIBLY_OUT_OF_SEGMENT: "It has been detected that this device may be on another thread",
  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "Information about the devices in the segment has been sent successfully!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "An error occurred while sending information about the devices in the segment.",
  SEARCH_POPUP_1: "To use the DN Physical Media part for the first time, it is recommended to select which devices belong to the segment.",
  SEARCH_POPUP_2: "Press the button below to search and find all reachable devices on the network.",
  SEARCH_POPUP_3_1: "After the search, the found devices will be added to the list of ",
  SEARCH_POPUP_3_2: "available devices",
  SEARCH_POPUP_3_3: " next to. Available devices ",
  SEARCH_POPUP_3_4: "are all those found, which belong to the current network segment, or not.",
  SEARCH_POPUP_4_1: "The other list, of ",
  SEARCH_POPUP_4_2: "selected devices",
  SEARCH_POPUP_4_3: ", is the list that ",
  SEARCH_POPUP_4_4: "contains the devices selected by the user that he is sure are on the current network segment.",
  SEARCH_POPUP_4_5: " Initially this list will be empty.",
  SEARCH_POPUP_5: "Once the search is done, it will be up to the user to select which of these devices actually belong to the network segment, moving them from the list of available devices to the list of selected devices.",
  SEARCH_POPUP_6_1: "NOTE: ",
  SEARCH_POPUP_6_2: "Network masters are always monitored by TS Monitor DeviceNet, therefore they do not appear on this page.",
  SAVE_POPUP_1_1: "By clicking the button below, the devices in the list ",
  SAVE_POPUP_1_2: "Selected devices",
  SAVE_POPUP_1_3: " will be saved.",
  SAVE_POPUP_2_1: "When performing this procedure, only the devices in the list ",
  SAVE_POPUP_2_2: "Selected devices",
  SAVE_POPUP_2_3: " will be monitored by the DN Physical Environment, and ",
  SAVE_POPUP_2_4: "only they will be shown on the DN Physical Media screens, such as: Live List, Matrix, Oscilloscope, etc.",
  EXPLANATION: "Explanation",
  SAVE_POPUP_3: "This functionality is important to identify devices belonging to the DeviceNet network segment. This reduces response time since the system will be checking the relevant devices.",
  SAVE_POPUP_4: "It is also of great value so that those who have less knowledge of the network do not look for the problem in the wrong segment.",
  AVAILABLE_DEVICES: "Available devices",
  AVAILABLE_DEVICES_POPUP_1_1: "This list contains all devices ",
  AVAILABLE_DEVICES_POPUP_1_2: "found on the network.",
  AVAILABLE_DEVICES_POPUP_2: "TS Monitor DeviceNet suggests devices that it believes belong to the current network segment, indicating them as: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identified as belonging.",
  AVAILABLE_DEVICES_POPUP_3_1: "Click on the button ",
  AVAILABLE_DEVICES_POPUP_3_2: " moves a device from the list of ",
  AVAILABLE_DEVICES_POPUP_3_3: "available devices",
  AVAILABLE_DEVICES_POPUP_3_4: " to the list of ",
  AVAILABLE_DEVICES_POPUP_3_5: "selected devices",
  AVAILABLE_DEVICES_POPUP_3_6: ", indicating that it belongs to the current network segment. After moving the devices, you need to click on the button ",
  AVAILABLE_DEVICES_POPUP_3_7: "Save",
  AVAILABLE_DEVICES_POPUP_3_8: " to save these changes.",
  AVAILABLE_DEVICES_POPUP_4_1: "NOTE: ",
  AVAILABLE_DEVICES_POPUP_4_2: "It is up to the user to make the final decision and decide which devices really belong to the segment.",
  LOADING_DEVICES: "Charging devices",
  MOVE_ALL: "Move all",
  SELECTED_DEVICES: "Selected devices",
  SELECTED_DEVICES_POPUP_1_1: "This list contains all devices that the user has marked as ",
  SELECTED_DEVICES_POPUP_1_2: "belonging to the current network segment.",
  SELECTED_DEVICES_POPUP_2_1: "It is important to note that after clicking the button ",
  SELECTED_DEVICES_POPUP_2_2: "Save",
  SELECTED_DEVICES_POPUP_2_3: ", the part of Physical Environment DN ",
  SELECTED_DEVICES_POPUP_2_4: "will only monitor devices that are in the list of selected devices.",
  SELECTED_DEVICES_POPUP_3_1: "This means that:",
  SELECTED_DEVICES_POPUP_3_2: " Devices that are not in this list will not be shown on the DN Physical Media screens, such as: Live list, Matrix, Oscilloscope, Bar graph, etc.",
  CONFIRM_SEARCH_START: "Are you sure you want to start the search?",
  CONFIRM_SEARCH_START_POPUP_1_1: "The device search procedure will take ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (five) minutes",
  CONFIRM_SEARCH_START_POPUP_1_3: " to be completed.",
  CONFIRM_SEARCH_START_POPUP_2_1: " During the search ",
  CONFIRM_SEARCH_START_POPUP_2_2: "several internal procedures of TS Monitor DeviceNet will be restarted",
  CONFIRM_SEARCH_START_POPUP_2_3: ", and for this reason, it will only function normally again after the search is completed.",
  SEARCHING_DEVICES: "Searching for devices.",
  PLEASE_STAY_IN_PAGE: "Please stay on the page to monitor the progress of the search.",
  SENDING_DEVICES_INFO: "Sending information about devices, please wait.",
  TIME_ON_PROTOCOL: "On time: ",
  NUM_OF_DEVICES: "Number of devices",
  MISSING: "Missing",
  NO_RETRIES: "No retries",
  OCUP_BANDA: "BAND OCCUPANCY (%)",
  CYCLE_TIME_S: "CYCLE TIME(s)",
  CYCLE_TIME_MS: "CYCLE TIME (ms)",
  MONITOR_TAG_STRONG: "MONITOR TAG",
  WATCHDOG_MS: "WATCHDOG (ms)",
  RETRIES_LIMIT: "RETRY LIMIT",
  DEVICENET_NETWORK_INFO: "Network information DeviceNet",
  HSA_POPUP_1: "HSA (Highest DeviceNet Address) is the parameter that indicates the highest address at which the master searches for new equipment on the network, using the FDL_Status protocol.",
  HSA_POPUP_2: "Also used to detect class 2 masters or networks with more than one master.",
  LOST: "Lost",
  FALHA: "Faults",
  RETRIE: "Retries",
  DIAGNOSTICS: "Diagnostics",
  STATUS_DEVICE: "Status",
  MANUFACTURER_MODEL: "Manufacturer/Model",
  ALTER_TAG_ERROR_REASON: ".\nReason: ",
  ERROR_REASON: ".\nReason: ",
  DN_CAPACITIVE_EFFECT_LOG_DESCRIPTION: "TS Expert has detected a capacitive effect condition.",
  DN_NOISE_LOG_DESCRIPTION: "TS Expert has detected a possible noise condition on the DeviceNet network.",
  DN_DIAGNOSTIC_LOG_DESCRIPTION: "TS Expert detected diagnostics.",
  DN_FAULT_LOG_DESCRIPTION: "TS Expert detected a failure.",
  DN_RETRIES_LOG_DESCRIPTION: "TS Expert detected retries.",
  DN_ERROR_FRAME_LOG_DESCRIPTION: "TS Expert detected an error frame.",
  PROTOCOL_RETRIES_LOG_DESCRIPTION: "TS Expert detected retries on the device.",
  PROTOCOL_ERROR_FRAME_LOG_DESCRIPTION: "TS Expert detected an error frame on the network.",
  EVENT_CHECKED_SUCCESS_PROTOCOL: "The event was successfully cleared.",
  SEND_FILE_WRONG_FILENAME_PROTOCOL: "Invalid name. The update file must be called: updateDN.tar.gz.gpg",
  LOOPBACK_IP_PROTOCOL: "\n- The loopback IP (127.0.0.1) cannot be used as the monitor's IP",
  TAG_TOO_LONG_PROTOCOL: "Tag length cannot exceed 30 characters",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Monitor DN detected that there is an overlap of addresses between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the ETHERNET interface with the chosen IP address and mask.",
  RESTART_SYSTEM_PROTOCOL: " Restart system",
  UPDATING_MONITOR_FILES_PROTOCOL: "Updating files on the monitor. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY_PROTOCOL: "Files updated, preparing to restart the monitor.",
  RESTARTING_MONITOR_WAIT_PROTOCOL: "Restarting the monitor, wait a few minutes.",
  UPDATE_ERROR_STRING_PROTOCOL: "The following error occurred when updating the monitor: ",
  TAG_WAS_CHANGED_SUCCESSFULLY_PROTOCOL: "The monitor tag has been successfully modified.",
  TAG_CHANGE_FAILURE_PROTOCOL: "An error occurred while modifying the monitor tag.",
  TAG_CONFIG_PROTOCOL: "Network tag",
  ETHERNET_POPUP_2_PROTOCOL: "Used for supervision and web access to monitor data.",
  WLAN_POPUP_2_PROTOCOL: "Used for supervision and web access to monitor data.",
  TURN_NTP_SERVER_ON_QUESTION_PROTOCOL: "Are you sure you want to turn on the NTP server? To do this, the monitor will need to be restarted.",
  MONITOR_RESTART_SUCCESS_PROTOCOL: "The monitor has been successfully reset.",
  MONITOR_RESTART_FAILURE_PROTOCOL: "An error occurred while restarting the monitor.",
  UPDATE_WLAN_CONFIG_ERROR_PROTOCOL: "Unable to connect to the WLAN network. If the problem persists, try restarting the monitor or the WLAN router.",
  ARE_YOU_SURE_ALTER_CONFIG_PROTOCOL: "Are you sure you want to change the TS Monitor DN settings?",
  GSD_FILES: "GSD files",
  ALTER_MONITOR_WLAN_CONFIG_PROTOCOL: "Are you sure you want to change the monitor's WLAN settings?",
  WLAN_STATUS_POPUP_1_PROTOCOL: "Indicates the state of the monitor's WLAN adapter.",
  CONNECTION_STATUS_POPUP_1_PROTOCOL: "Indicates whether or not the monitor is connected to the configured WLAN network.",
  WLAN_CONFIG_POPUP_2_PROTOCOL: "It is highly recommended that WLAN settings be changed only when accessing the monitor via a wired network.",
  WLAN_ADAPTER_NOT_FOUND_1_PROTOCOL: "TS Monitor DeviceNet could not find adapter WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2_PROTOCOL: "  • Check if the adapter is disconnected or has poor contact;\n",
  WLAN_ADAPTER_NOT_FOUND_3_PROTOCOL: "  • If the adapter is not disconnected or has poor contact, try replacing it;\n",
  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "Are you sure you want to change the hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "To do this, you need to restart the monitor.",
  DISP_DIAG: "Device",
  DIAGNOSTIC1: "Diagnostic 1",
  DIAGNOSTIC2: "Diagnostic 2",
  DIAGNOSTIC3: "Diagnostic 3",
  DIAGNOSTIC4: "Diagnostic 4",
  DIAGNOSTIC5: "Diagnostic 5",
  DIAGNOSTIC6: "Diagnostic 6",
  DIAGNOSTIC7: "Diagnostic 7",
  DIAGNOSTIC8: "Diagnostic 8",
  DIAGNOSTIC_LIST: "List of diagnoses",
  DATA_FIELD_PLACEHODLER: "Date",
  BIT1: "Bit 1:",
  BIT2: "Bit 2:",
  BIT3: "Bit 3:",
  BIT4: "Bit 4:",
  BIT5: "Bit 5:",
  BIT6: "Bit 6:",
  BIT7: "Bit 7:",
  BIT8: "Bit 8:",
  DIAG_SUCcESS_MSG: "The diagnostic was successfully changed.",
  REMOVE_DIAG_FAILURE: "An error occurred when changing the diagnostic and tags",
  REMOVE_GSD_SUCCESS: "The GSD files were successfully removed",
  REMOVE_GSD_FILES: "Manage GSD files",
  REMOVING_GSD_FILES: "Removing GSD files",
  FILTER_GSD_FILES: "Filter GSD files",
  DeviceNet: "DeviceNet",
  REPORT_EXPORT_NAME_PROTOCOL: "Report TS Monitor DeviceNet",
  HEADER_TEXT_PROTOCOL: "Data Report - TS Monitor DeviceNet - Protocol",
  TAG_NAME_DN: "- Network Tag: ",
  MONITOR_VERSION_DN: "- Monitor version: ",
  MONITOR_INIT_DN: "- Start of monitoring: ",
  GENERATING_TIME_DN: "- Report generation: ",
  DURATION_SINCE_MON_BEGIN: "- Duration of monitoring until report generation: ",
  BAUD_RATE_PROTOCOL: "Baud rate: ",
  CYCLE_TIME_PROTOCOL: "Cycle time: ",
  OCUP_BANDA_DN: "Bandwidth Occupancy (%): ",
  MASTERS_DN: "Masters: ",
  SLAVES_DN: "Devices: ",
  ONLINE_SLAVES_DP: "Devices online: ",
  MISSING_DN: "Missing: ",
  RETRIES_DN: "Retries: ",
  DIAGNOSTIC_DN: "Diagnostics: ",
  FAULT_DN: "Faults: ",
  ERROR_FRAME: "Error Frames: ",
  WATCHDOG_DP: "Watchdog: ",
  RETRIES_LIMIT_DP: "Retry limit: ",
  HSA_DP: "HSA: ",
  M_MONITORING_RESUME_PAGE_TITLE: "1.1. - Summary",
  PROTOCOL_RESUME_PAGE_TITLE: "1. - Summary",
  PROTOCOL_LIVE_LIST_PAGE_TITLE: "2. Live List",
  PROTOCOL_LOG_PAGE_TITLE: "3. - Event log",
  ONLINE_STRING: "Online",
  MISSING_PLURAL_STRING: "Missing",
  MISSING_SINGULAR_STRING: "Missing",
  PARAM_ERROR_STRING: "Parameterization error",
  GOOD_STRING_PROTOCOL: "OK",
  BAD_STRING_PROTOCOL: "Failure",
  DIAGNOSTIC_STRING: "Diagnostic",
  CRITIC_SLAVE_STRING: "Critical device",
  MASTER_FAULT_STRING: "Master",
  SLAVE_MASTER_FAULT_STRING: "Master of failure",
  MPI_STRING: "MPI",
  MPI_CSV_FAULT_STRING: "Failed MPI",
  MASTER_CLASS_2: "Master",
  MASTER_OPERATE: "Master - operate",
  MASTER_SYNC: "Master - sync",
  MASTER_UNSYNC: "Master - unsync",
  MASTER_FREEZE: "Master - freeze",
  MASTER_UNFREEZE: "Master - unfreeze",
  MASTER_CLEAR: "Master - clear",
  MASTER_OPERATE_CAPITAL: "Master - Operate",
  MASTER_SYNC_CAPITAL: "Master - Sync",
  MASTER_UNSYNC_CAPITAL: "Master - Unsync",
  MASTER_FREEZE_CAPITAL: "Master - Freeze",
  MASTER_UNFREEZE_CAPITAL: "Master - Unfreeze",
  MASTER_CLEAR_CAPITAL: "Master - Clear",
  WITH_CRITICAL_SLAVE_STRING: "The network has devices in critical condition",
  WITH_MASTER_FAULT_STRING: "The network has masters in failure",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_PROTOCOL: "Filter by address or status",
  LOG_INPUT_TEXT_PLACEHOLDER_PROTOCOL: "Filter by address and tag",
  SLAVE_DIAGNOSTIC: "Device diagnostic:",
  NETWORK_EVENT: "Network event",
  MASTER_HASHTAG: "Master #",
  CONFIG_ERROR_1: "error ",
  CONFIG_ERROR_2: "configuration",
  PARAM_ERROR_1: "error ",
  PARAM_ERROR_2: "parameterization",
  DIAGNOSTICS_STRING: "Diagnostics",
  ERROR_FRAMES_STRING: "Error Frames (First detection)",
  ERROR_FRAMES_UPDATE_STRING: "Error Frames",
  RETRIES_STRING: "Retries",
  NUM_OF_DEVICES_STRING: "Number of Devices",
  FAULTS_STRING: "Faults",
  WATCHDOG_STRING: "Watchdog",
  BILLION_OF: "billion of",
  MILLION_OF: "Million of",
  LAST_EVENT_TOO_BIG_STRING: "Very long description, please consult the log.",
  CRITICAL_SLAVE_EXPLANATION: "The TS monitor has an automatic function of selecting devices that have an excessive number of events and informs the user that this device is critical to the DeviceNet network.",
  DIAGNOSTICS_QUESTION_INFO: " Indicates the number of diagnostics detected on the DeviceNet network. Diagnostics indicate abnormal device status conditions, such as short circuit, power problem, missing module, etc.",
  RETRIES_QUESTION_INFO: "Indicates the number of times that the master needed to resend a message to a given device after not receiving a response. It usually indicates problems in the physical environment.",
  WATCHDOG_QUESTION_INFO_1: "The watchdog is the time that the device waits after losing communication with the master until it changes its outputs to a safe condition.",
  WATCHDOG_QUESTION_INFO_2: "This parameter is sent by the master to all devices on the network, individually, in their respective parameterization telegram.",
  WATCHDOG_QUESTION_INFO_3: "If the cycle time is close to the watchdog, the network becomes more vulnerable.",
  WATCHDOG_QUESTION_INFO: "Indicates whether the watchdog for the device is active, inactive, or has not yet been parameterized.",
  EDIT_TOPOLOGY_POS_STRING: "Edit",
  EXPORT_SVG: "SVG",
  ALERT_NOT_POSSIBLE_TO_EDIT: "Unable to edit master data",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "Unable to edit TS Monitor data",
  ALERT_NOT_POSSIBLE_TO_DELETE: "It is not possible to remove a device from the live list",
  ALERT_CHOOSE_CONNECTION_TYPE: "Please select a connection type",
  ADD_CONNECTION: "Add connection",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a connection type",
  EDIT_DEVICE: "Edit device",
  MASTER_NAME: "Master",
  SLAVE_NAME: "Device",
  SLAVE_PA_NAME: "Device",
  REPEATER_NAME: "Repeater",
  HUB_NAME: "Hub",
  JB_NAME: "Junction Box",
  COUPLER_PROXY_NAME: "Coupler/Proxy",
  FIBER_LINK_NAME: "Fiber Link",
  ACTIVE_TERMINATION_NAME: "Active Terminator",
  UNKNOWN_NAME: "Unknown",
  TS_MONITOR_NAME: "TS Monitor",
  MPI_NAME: "MPI",
  FORM_NO_DEVICE_FOUND_PREFIX: "The address device ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " was not found",
  INSERT_VALID_ADDRESS_OR_TAG: "Please enter a valid address or tag",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Please enter a valid address or tag",
  POSITIONING_CONFLICT_1: "There is a conflict in the device address information:",
  POSITIONING_CONFLICT_2: "\nBecause of this, your positions and connections will return to their default state.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Mates and connections returned to default state successfully",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "The following error occurred when returning mates and connections to their default state: ",
  COLORS_LABELS: "Color legend",
  LABEL_SLAVE_OK_MASTER_OP: ": Device ok, and master operating;",
  LABEL_MASTER_STOP_CLEAR: ": Master in STOP / CLEAR;",
  LABEL_SLAVE_DIAG: ": Device in diagnostic;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Device in failure, and master in failure;",
  LABEL_SLAVE_CONFIG_ERROR: ": Device with configuration error;",
  LABEL_SLAVE_PARAM_ERROR: ": Device with parameterization error;",
  LABEL_SLAVE_ONLINE: ": Device online;",
  LABEL_SLAVE_MISSING: ": Device missing;",
  LABEL_SLAVE_MASTER_FAULT: ": Device with faulty master;",
  LABEL_SLAVE_BLACKLIST: ": Device on blacklist;",
  LABEL_CRITICAL_SLAVE: ": Critical device;",
  LABEL_MPI: ":MPI;",
  LABEL_NO_STATUS: ": Device without status.",
  DEVICE_TAG_NOT_FOUND: "No device was found with the TAG: ",
  INSERT_VALID_ADDRESS_1_127: "Enter a valid device address, between 1 and 127.",
  DEVICE_WITH_ADDRESS: "The address device ",
  WAS_SUCCESSFULLY_ADDED: " has been added successfully.",
  WAS_SUCCESSFULLY_REMOVED: " has been successfully removed.",
  IS_ALREADY_IN_NETWORK: " It's already on the network.",
  REMOVE_DEVICE_ERROR: "The following error occurred when trying to remove the device: ",
  TS_SCOPE_NOT_FOUND: "Unable to find TS Monitor of IP:",
  INVALID_INSERTED_IP: "The IP entered is invalid",
  TS_SCOPE_FETCH_SUCCESS: "Fetch of TS Monitor was successful",
  CONFIG_RETRIES_LIST_HEADER: "Retries",
  CONFIG_RETRIES_LIST_CONTENT: "When this option is activated, TS Expert will indicate all retry attempts, per device",
  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Failure sequence",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "When this option is activated, TS Expert will record all failures that occurred in sequence in the event of failures of several devices.",
  CONFIG_CONFIG_ERROR_LIST_HEADER: "Configuration error",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "When this option is activated, TS Expert will indicate all devices that have a configuration error.",
  CONFIG_ERROR_FRAME_LIST_HEADER: "Error Frame",
  ERROR_FRAME_LIST_CONTENT: "When this option is activated, TS Expert will indicate the occurrence of error frames.",
  CONFIG_PARAM_ERROR_LIST_HEADER: "Parameterization error",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "When this option is activated, TS Expert will indicate all devices that have a parameterization error.",
  CONFIG_MISSING_LIST_HEADER: "Device missing",
  CONFIG_MISSING_LIST_CONTENT: "When this option is activated, TS Expert will indicate all missing devices.",
  CONFIG_ONLINE_LIST_HEADER: "Device online",
  CONFIG_ONLINE_LIST_CONTENT: "When this option is activated, TS Expert will indicate all devices online.",
  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Critical device",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "When this option is activated, TS Expert will register all critical devices.",
  CONFIG_MASTER_FAULT_LIST_HEADER: "Master of failure",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "When this option is activated, TS Expert will indicate when TS Monitor is not receiving DeviceNet frames.",
  TS_EXPERT_REPORT_EXPORT_NAME_PROTOCOL: "Action list - TS Expert - DeviceNet",
  TS_EXPERT_POPUP_2_PROTOCOL: "This tool is an expert system developed to optimize and accelerate the analysis of the main divergences detected by TS Monitor in DeviceNet networks.",
  RETRIES_LIST_HEADER: "There are devices on the network that have retries.",
  DEVICE_WITH_RETRIES: "Device with retries (First Detection)",
  DEVICE_UPDATE_WITH_RETRIES: "Device with retries",
  RETRIES_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as they still have retries:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "Unable to check device event as they still have retries\n",
  RETRIES_SUGGESTION_1: "When a device has retries, it is suggested:",
  RETRIES_SUGGESTION_2: "Retries indicate the number of times that the master needed to resend a message to a given device after not receiving a response, either because the device did not respond or because the response was corrupted (illegal or incomplete frame), due to noise, low isolation in the device or in the bus infrastructure.",
  RETRIES_SUGGESTION_3: "Check and correct the assembly of connections;",
  RETRIES_SUGGESTION_4: "Check for damage to the DeviceNet cable, such as:",
  RETRIES_SUGGESTION_5: "Bends smaller than 10 times the radius of the conductor;",
  RETRIES_SUGGESTION_6: "Cuts in the cable;",
  RETRIES_SUGGESTION_7: "Twists in the cable;",
  RETRIES_SUGGESTION_8: "Dents on the cable.",
  RETRIES_SUGGESTION_9: "These non-conformities require the replacement of the cable section (it is not possible to resolve the non-conformity by unfolding or uncrumpling the cable);",
  RETRIES_SUGGESTION_10: "Check for power cables near DeviceNet cables. Data cables must be separated as far as possible or in closed and grounded cable trays/conducts, following the minimum indicated by the guidelines according to the classification of the electrical conductor, standard EN50174;",
  RETRIES_SUGGESTION_11: "Measure leakage current in the cable with suitable pliers. If the measurement is greater than 100mA, it is necessary to check the equipotentialization and the grounding system;",
  RETRIES_SUGGESTION_12: "Checking the signal quality with the DeivceNet physical medium, which will give you tips according to the measurements carried out;",
  RETRIES_SUGGESTION_13: "If none of the above items resolves the problem, and a specific device is experiencing retries in isolation (only a specific device is experiencing retries), it is suggested to replace the device's network interface.",
  RETRIES_SUGGESTION_14: "The only item that may have better results with the plant running is item “e”, however the use of an analyzer must be carried out with caution as if the signal condition is too compromised it could bring down the network.",
  DEVICE_UPDATE_WITH_DIAGNOSTIC: "Device with diagnostics",
  DIAGNOSTIC_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as they still have diagnostics:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "Unable to check device event as it still has diagnostics\n",
  DIAGNOSTIC_SUGGESTION_3: "If a device presents a diagnostic, check the information sent and try to solve the problem. If you have difficulty understanding the diagnostic, contact the device manufacturer to resolve your doubts before an intervention;",
  DIAGNOSTIC_SUGGESTION_4: "The increasing number of diagnoses without maintenance data may be directly linked to device failures, as when the equipment communicates again there is a conference diagnostic, which checks whether the device is ready to exchange data. Check if the diagnostic number is close to the fault number, in this case follow the fault test step-by-step.",
  FAULT_LIST_HEADER: "There are devices on the network that have faults.",
  DEVICE_UPDATE_WITH_FAULT: "Device with faults",
  FAULT_INITIAL_ERROR_MSG: "It was not possible to check the events of the following devices, as they still have faults:\n",
  S_FAULT_INITIAL_ERROR_MSG: "Unable to check device event as it still has faults\n",
  ERROR_FRAME_MSG: "It was not possible to check the event, as the network still has error frames\n",
  ERROR_FRAME_LIST_HEADER: "Error Frame.",
  DEVICE_WITH_ERROR_FRAME: "Error Frame (First detection)",
  DEVICE_WITH_UPDATE_ERROR_FRAME: "Error Frame",
  ERROR_FRAME_SUGGESTION_1: "When an error frame is detected on the network, we suggest:",
  ERROR_FRAME_SUGGESTION_2: "The frame error indicates that an incorrect message was sent, either due to the lack of stuff bit in the message, incorrect CRC, or the response was corrupt (illegal or incomplete frame).",
  ERROR_FRAME_SUGGESTION_3: "Check and correct the assembly of connections;",
  ERROR_FRAME_SUGGESTION_4: "Check for damage to the DeviceNet cable, such as:",
  ERROR_FRAME_SUGGESTION_5: "Bends smaller than 10 times the radius of the conductor;",
  ERROR_FRAME_SUGGESTION_6: "Cuts in the cable;",
  ERROR_FRAME_SUGGESTION_7: "Twists in the cable;",
  ERROR_FRAME_SUGGESTION_8: "Dents on the cable.",
  ERROR_FRAME_SUGGESTION_9: "These non-conformities require the replacement of the cable section (it is not possible to resolve the non-conformity by unfolding or uncrumpling the cable);",
  ERROR_FRAME_SUGGESTION_10: "Check for power cables near DeviceNet cables. Data cables must be separated as far as possible or in closed and grounded cable trays/conducts, following the minimum indicated by the guidelines according to the classification of the electrical conductor, standard EN50174;",
  ERROR_FRAME_SUGGESTION_11: "Measure leakage current in the cable with suitable pliers. If the measurement is greater than 100mA, it is necessary to check the equipotentialization and the grounding system;",
  ERROR_FRAME_SUGGESTION_12: "Checking the signal quality with the DeviceNet physical medium, which will give you tips according to the measurements carried out;",
  ERROR_FRAME_SUGGESTION_13: "If none of the above items resolves the problem, and a specific device is experiencing retries in isolation (only a specific device is experiencing retries), it is suggested to replace the device's network interface.",
  ERROR_FRAME_SUGGESTION_14: "The only item that may have better results with the plant running is item “e”, however the use of an analyzer must be carried out with caution as if the signal condition is too compromised it could bring down the network.",
  MISSING_LIST_HEADER: "There are devices missing on the network.",
  DEVICE_MISSING: "Missing device",
  DEVICE_MISSING_UPDATE: "Missing device",
  MISSING_INITIAL_ERROR_MSG: "Unable to check events for the following devices as they are still missing:\n",
  S_MISSING_INITIAL_ERROR_MSG: "Unable to check device event as it is still missing\n",
  MISSING_SUGGESTION_1: "When a device is missing it is suggested:",
  MISSING_SUGGESTION_2: "It occurs when the master or DCS is searching for a device on the network but does not receive a response. This device was configured in the project, but is not responding on the network or is not installed. Suggestion:",
  MISSING_SUGGESTION_3: "Check whether the device declared in the master software or DCS is connected to the network and powered.",
  MISSING_SUGGESTION_4: "It is not recommended to leave the master or SDCD searching for devices that will not be installed.",
  SIGNAL_QUALITY_GOOD_DESCRIPTION: "• Average Amplitude greater than or equal to 2Vpp.",
  ATTENTION_PREVENTIVE_ACTION_MINIMUM: "• Average amplitude greater than or equal to 1.5Vpp.",
  ATTENTION_PREVENTIVE_ACTION_MAXIMUM: "• Average amplitude less than 2Vpp.",
  BAD_CORRECTIVE_ACTION_DESCRIPTION: "• Average amplitude less than 1.5Vpp.",
  EMAIL: "E-mail",
  HOSTNAME: "Hostname",
  TIMEZONE: "Timezone",
  DHCP: "DHCP",
  RELATIVE_TIME_YEAR: "{value} year",
  RELATIVE_TIME_YEARS: "{value} years",
  RELATIVE_TIME_MONTH: "{value} month",
  RELATIVE_TIME_MONTHS: "{value} months",
  RELATIVE_TIME_DAY: "{value} day",
  RELATIVE_TIME_DAYS: "{value} days",
  RELATIVE_TIME_HOUR: "{value} hour",
  RELATIVE_TIME_HOURS: "{value} hours",
  RELATIVE_TIME_MINUTE: "{value} minute",
  RELATIVE_TIME_MINUTES: "{value} minutes",
  CHART_TIME_VALUE: "Time: ",
  CHART_ADDRESS: "Address: ",
  CHART_LOCALE: "en",
  CHART_MONTHS: "January|February|March|April|May|June|July|August|September|October|November|December",
  CHART_SHORT_MONTHS: "Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec",
  CHART_DAYS: "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday",
  CHART_SHORT_DAYS: "Sun|Mon|Tue|Wed|Thu|Fri|Sat",
  CHART_EXPORT_SVG: "Download SVG",
  CHART_EXPORT_PNG: "Download PNG",
  CHART_EXPORT_CSV: "Download CSV",
  CHART_MENU: "Download",
  CHART_SELECTION: "Select",
  CHART_SELECTION_ZOOM: "Selection zoom",
  CHART_ZOOM_IN: "Zoom in",
  CHART_ZOOM_OUT: "Zoom out",
  CHART_PAN: "Pan",
  SAVE_REPORT: "Save report",
  FINALIZING: "Finalizing...",
  ACTION_LIST_TITLE: "Action List - TS Monitor DN",
  SAVE_ACTION_LIST: "Save action list",
  CHART_RESET_ZOOM: "Reset zoom",
  GOOD_PREVENTIVE_ACTION_DESCRIPTION: "• Average amplitude greater than or equal to 2Vpp.",
  ATTENTION_PREVENTIVE_ACTION_DESCRIPTION_1: "• Average amplitude greater than or equal to 1.5Vpp.",
  ATTENTION_PREVENTIVE_ACTION_DESCRIPTION_2: "• Average amplitude less than 2Vpp."
});
